module.exports = __webpack_public_path__ + "img/ios-partly-sunny.a3ff3d09.svg";